import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { searchLayer } from '../../layers';
import {  searchLayers } from '../../search';
import { addClass, removeClass } from '../../../bgis/util/dom';
import { adressApi } from './fetchAdressApi';
import { ScoreableSearchResult  } from '../../interfaces/interfaces';
import { updateSearchLayer } from '../../layers';

// First, create the thunk
export const searchByQuery = createAsyncThunk(
  'users/fetchByIdStatus',
  async (query: string, thunkAPI) => {
    if (!query || query.length < 3) {
      const response = await Promise.reject(query);
      return response;
    } else {
      const response = await searchLayers(query);
      return response;
    }
  }
)

/** */
export const searchAdressByQuery = createAsyncThunk('search/fetchAdress',
  async (query: string, thunkAPI) => {
    const response = adressApi.useSearchAdressQuery(query);
    return response.data;
  });





interface SearchState {
  /* search */
  minLength: number, // The number of chars after which the search starts.
  query?: string, // The query string.
  results?: ScoreableSearchResult[], // The resulting search results.
  limit: number, // the maximal number of hits that are displayed.
  isSearching: boolean,
  isShowDetails: boolean
}






// Initial search state
const initialState: SearchState = {
  minLength: 3,
  isSearching: false,
  isShowDetails: false,
  query: undefined,
  results: undefined,
  limit: 20

}


export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.isSearching = false;
      state.isShowDetails = false;
      state.query = undefined;
      state.results = undefined;
    },
    setQuery: (state, action:PayloadAction<string|undefined>) => {
      state.query = action.payload;
    },
    selectSearchResult: (state, action: PayloadAction<string>) => {
      if (state.results && state.results.length) {
        state.results.forEach(result => {
          if (result.id === action.payload) {
            state.results = [result];
            state.query = result.label;
            updateSearchLayer(state.results);
            state.isShowDetails = false;
            removeClass('.bgis-map-area', 'show-search-details');

          }
        })
      }
    }
  },
  /* are used for async processing in combination with asyc thunks */
  extraReducers: (builder) => {
    builder.addCase(
      searchByQuery.pending, (state, action) => {
        searchLayer.getSource()?.clear(); // remove all previous entries (if any)
        state.isSearching = true;
      }
    ).addCase(searchByQuery.fulfilled, (state, action) => {
      addClass('.bgis-map-area', 'show-search-details');
      // Add user to the state array
      state.results = action.payload;
      /* add the features */
       updateSearchLayer(state.results);
      state.isSearching = false;
      state.isShowDetails = true;
    }
    ).addCase(
      searchByQuery.rejected, (state, action) => {
        // Add user to the state array
        state.results = undefined;
        state.isSearching = false;
        removeClass('.bgis-map-area', 'show-search-details');
      }
    ).addMatcher(adressApi.endpoints.searchAdress.matchRejected,
      (state, { payload }) => {
        console.log("unable to get adresses");
      }).addMatcher(adressApi.endpoints.searchAdress.matchFulfilled,
        (state, { payload }) => {
          console.log("adressSearch result");
          console.log(payload);
        }
      ).addMatcher(adressApi.endpoints.searchAdress.matchRejected,
        (state, { payload }) => {
          console.log("unable to get the filtered measuring point sites");
        })
  }




}

);

export const { clearSearch, selectSearchResult, setQuery } = searchSlice.actions;




